// extracted by mini-css-extract-plugin
module.exports = {"card":"b429494557--card--d0v6d","date":"b429494557--date--EIN2x","description":"b429494557--description--CfUtv"};